import { render, staticRenderFns } from "./SingleZoneStandart.vue?vue&type=template&id=a773d060&scoped=true"
import script from "./SingleZoneStandart.vue?vue&type=script&lang=js"
export * from "./SingleZoneStandart.vue?vue&type=script&lang=js"
import style0 from "./SingleZoneStandart.vue?vue&type=style&index=0&id=a773d060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a773d060",
  null
  
)

export default component.exports